import { cn } from '@sohanemon/utils';
import { m } from '@sohanscript/i18n';
import type * as React from 'react';

type ContactInfoProps = React.ComponentProps<'div'>;

export function ContactInfo({ className, ...props }: ContactInfoProps) {
	return (
		<div
			className={cn('shrink-0 rounded-sm border border-border p-4', className)}
			{...props}
		>
			<p className="mb-3 font-mono text-4xs text-muted-foreground uppercase tracking-widest">
				{m.resume_contact()}
			</p>
			{[
				{
					label: m.resume_email(),
					value: 'sohanemon@outlook.com',
					href: 'mailto:sohanemon@outlook.com',
				},
				{
					label: m.resume_web(),
					value: 'sohanscript.web.app',
					href: 'https://sohanscript.web.app',
				},
				{
					label: m.resume_github(),
					value: 'github.com/sohanemon',
					href: 'https://github.com/sohanemon',
				},
				{ label: m.resume_location(), value: 'Dhaka, Bangladesh' },
			].map(({ label, value, href }) => (
				<div
					key={label}
					className="flex items-start justify-between gap-3 border-border border-b py-1.5 last:border-0 last:pb-0"
				>
					<span className="shrink-0 font-mono text-3xs text-muted-foreground">
						{label}
					</span>
					{href ? (
						<a
							href={href}
							target="_blank"
							rel="noopener noreferrer"
							className="break-all text-right font-mono font-semibold text-3xs text-primary hover:underline"
						>
							{value}
						</a>
					) : (
						<span className="text-right font-mono font-semibold text-3xs text-foreground">
							{value}
						</span>
					)}
				</div>
			))}
			<div className="border-border pt-2">
				<span className="font-mono font-semibold text-[8px] text-primary uppercase tracking-widest">
					{m.resume_available()}
				</span>
			</div>
		</div>
	);
}
